import React from 'preact/compat';
import { h } from 'preact';
import InputField, { InputFieldProps } from '@ingka/input-field';
import { PREFIX } from 'list/DesignSystem/constants';
import './inputField.scss';

export default (props: InputFieldProps) => <InputField prefix={PREFIX} {...props} />;
